export default {
  //
}



// WEBPACK FOOTER //
// ./src/store/mutations.js